import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonBlock, Content, ContentText } from './styled';
import { BackButton } from '../styled';
import { BaseQuizProps } from 'containers/pages/courses-list/types';

const TeacherWelcome: FC<BaseQuizProps> = ({ back }) => {
    const { t } = useTranslation('pages/quiz');

    return (
        <Content>
            <ContentText>{t('teacher-welcome')}</ContentText>
            <ButtonBlock>
                <BackButton forwardedAs={'a'} href={'/academy-alliance/'}>
                    {t('next')}
                </BackButton>
                <BackButton onClick={back}>{t('pages/quiz:back')}</BackButton>
            </ButtonBlock>
        </Content>
    );
};

export default TeacherWelcome;
